const CREATE_GOAL_ENTRY_POINT_PERMISSIONS = ["goals:createGoal", "goals:viewCreateAGoalButton"];

/**
 * Whether an unscoped Create Goal entry point (toolbar button, wizard launcher) should be visible.
 * `goals:createGoal` is only granted on employee-scoped requests, so unscoped call sites must
 * accept either permission. Where the assignee is already fixed, gate on `goals:createGoal`.
 */
export const canViewCreateGoalEntryPoint = (permissions?: string[]): boolean =>
	CREATE_GOAL_ENTRY_POINT_PERMISSIONS.some((permission) => !!permissions?.includes(permission));
